import React, { useState, useContext, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import { IoIosArrowDropleftCircle } from "react-icons/io";
import CaseListTable from "../components/all-case-list/case-list-table/CaseListTable";
import AllDocumentsList from "../components/all-case-list/case-table/AllDocumentsList";
import { AuthContext } from "../context/Auth/AuthContext";
import Navbar from "../components/common/Navbar";
import baseUrl from "../config/baseUrl";
import "../styles/Documents.css";

const ProcessedCaseList = () => {
  const { is_admin } = useContext(AuthContext);

  const [tab, setTab] = useState([
    {
      id: uuidv4(),
      documentID: null,
      title: "Processed Cases",
      content: (addDocumentTab) => (
        <CaseListTable
          addDocumentTab={addDocumentTab}
          apiLink={`${baseUrl}/DMS/api/my_proccessed_api`}
          admin={is_admin}
          caseList="all"
          categoryName={document.category}
          assignUserFilter={true}
          folderName={document.uncategorized_from_name}
          assignPage={true}
          page="processed"
        />
      ),
      canClose: false,
    },
  ]);
  const [tabValue, setTabValue] = useState(tab[0].id);

  const scrollRef = useRef(null);

  const truncate = (string, n) => {
    return string?.length > n ? string.substr(0, n - 1) + "..." : string;
  };

  const scrollLeft = (scrollOffset) => {
    scrollRef.current.scrollLeft += scrollOffset;
  };

  const scrollRight = (scrollOffset) => {
    scrollRef.current.scrollLeft -= scrollOffset;
  };

  const changeActiveTab = () => {
    setTabValue(tab[0].id);
  };

  const addDocumentTab = (document) => {
    const isDocumentAlreadySelected = tab.find(
      (tab) => tab.documentID === document.documentID
    );

    if (isDocumentAlreadySelected !== undefined) {
      return;
    }

    const findIndex = tab.splice(1, 0, {
      id: uuidv4(),
      documentID: document.documentID,
      caseNo: document.case_number,
      title: truncate(document.NAME, 9),
      content: () => {
        return (
          <AllDocumentsList
            caseNo={document.case_number}
            caseList="processed"
            email={document.uncategorized_email}
            categoryName={document.category}
            folderName={document.uncategorized_from_name}
            assigned="TRUE"
          />
        );
      },
      canClose: true,
    });

    const filteredTab = tab.filter((value, index) => index !== findIndex);

    setTab(filteredTab);
  };

  const handleChange = (index) => {
    setTabValue(index);
  };

  const closeTab = (e, index) => {
    e.stopPropagation();
    const newTab = tab.filter((tab) => tab.id !== index);
    const allDocumentTabId = newTab[0].id;
    setTab(newTab);
    setTabValue(allDocumentTabId);
  };

  return (
    <div className="document-container">
      <div className="navbar">
        <Navbar />
      </div>
      <div className="document-content">
        <div
          className={tab.length > 7 ? "scrollable-tabs" : "not-scrollable-tabs"}
        >
          {tab.length > 7 ? (
            <div className="scroll-icons" onClick={() => scrollRight(150)}>
              <IoIosArrowDropleftCircle />
            </div>
          ) : null}
          <div className="tabs-header" ref={scrollRef}>
            {tab.map((tab, index) => (
              <div
                key={tab.id}
                className={
                  tabValue === tab.id
                    ? "tab-title active-tab-title"
                    : "tab-title"
                }
                onClick={() => handleChange(tab.id)}
              >
                <span>{tab.title}</span>
                {tab.canClose ? (
                  <button
                    className="tab-close-icon"
                    onClick={(e) => closeTab(e, tab.id)}
                  >
                    <AiOutlineCloseCircle />
                  </button>
                ) : null}
              </div>
            ))}
          </div>
          {tab.length > 7 ? (
            <div className="scroll-icons" onClick={() => scrollLeft(150)}>
              <IoIosArrowDroprightCircle />
            </div>
          ) : null}
        </div>
        <div className="tab-content">
          {tab.map((tab, index) => {
            return tabValue === tab.id ? (
              <div key={index}>
                {tab.title === "Processed Cases"
                  ? tab.content(addDocumentTab)
                  : tab.content()}
              </div>
            ) : null;
          })}
        </div>
      </div>
    </div>
  );
};

export default ProcessedCaseList;
